import { getMachinesByMachineUuidOwnerOrgsOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export type MachineOwnerOrg = { orgId: string; orgName: string };

export function useOwnerOrgsFromMachine({
  machineUuid,
  enabled,
}: {
  machineUuid?: string;
  enabled?: boolean;
}) {
  const { data, isLoading } = useQuery({
    ...getMachinesByMachineUuidOwnerOrgsOptions({
      path: { machine_uuid: machineUuid ?? "" },
    }),
    enabled: enabled ?? !!machineUuid,
  });

  const orgs = useMemo<MachineOwnerOrg[]>(() => {
    const seen = new Map<string, MachineOwnerOrg>();
    for (const o of data?.orgs ?? []) {
      if (!seen.has(o.orgId))
        seen.set(o.orgId, { orgId: o.orgId, orgName: o.orgName });
    }
    return [...seen.values()];
  }, [data]);

  return { orgs, count: orgs.length, isLoading } as const;
}
